import {Routes} from '@angular/router';
import {RolePermissionGuard} from '@shared/route-guards/auth.guard';
import {UserRole} from '@graphql/generated';
import {LoginGuard} from '@shared/route-guards/login.guard';

export const AppRoutes: Routes = [
  {
    path: 'admin',
    canActivate: [LoginGuard, RolePermissionGuard],
    data: {roles: [UserRole.A, UserRole.S]},
    loadChildren: () => import('@app/admin/admin.routes').then(m => m.AdminRoutes),
  },
  {
    path: 'portal',
    canActivate: [LoginGuard, RolePermissionGuard],
    data: {roles: [UserRole.C]},
    loadChildren: () => import('@app/portal/portal.routes').then(m => m.PortalRoutes),
  },
  {
    path: '',
    loadChildren: () => import('@app/public/public.routes').then(m => m.PublicRoutes),
  },
  {
    path: '**',
    // canActivate: [LoginGuard],
    loadChildren: () => import('@app/public/public.routes').then(m => m.PublicRoutes),
  }
];
